import store from '@/services/store.js';
import { EventBus } from '@/services/Event.js';
import EditProfile from '@/components/user/dashboard/pages/profile/edit-profile/edit-profile.vue';

export default {
    name: 'juniorOneDayMembershipMenu',
    components: {
        EditProfile
    },
    data() {
        return {
            isProcessing: true,
            juniors: [],
            junior: null,
            juniorId: null,
            juniorName: null
        }
    },
    computed: {
        changeJunior() {
            var self = this;
            if (self.junior && self.juniors && self.juniorName && self.junior.details.fullName != self.juniorName) {

                var id = self.getJuniorIdByName();
                if (id !== self.juniorId) {
                    EventBus.$emit("user-load-dashboard-card", id);
                    store.commit('setCurrentJunior', self.juniorName);
                    self.$console("Loaded data for junior - " + id + " - " + self.juniorName);
                }
            }
            return true;
        },
        domain() {
            return process.env.url.oldApp;
        },
    },
    methods: {
        getJuniorIdByName() {
            var self = this;
            var juniorArray = self.juniors.filter(junior => {
                return junior.fullName === self.juniorName;
            });
            if (juniorArray.length) {
                return juniorArray[0].id;
            }
            else {
                return self.juniors[0].id;
            }
        },
        getData() {
            var self = this;
            self.isProcessing = true;
            if (!self.juniors || !self.juniors.length) {
                self.getJuniors();
                return;
            }

            var preloadedUser = store.getters.getCurrentUserShortInfo;
            if (preloadedUser && preloadedUser.isSuccess) {
                self.junior = preloadedUser;
                self.juniorId = preloadedUser.details.id;
                self.$console();
                self.$console({ junior: self.junior });
                self.isProcessing = false;
            }
        },
        getJuniors() {
            var self = this;
            var preloadedUser = store.getters.getUserShortInfo;
            if (preloadedUser && preloadedUser.isSuccess) {
                if (preloadedUser.details.juniors && preloadedUser.details.juniors.length > 0) {
                    self.juniors = preloadedUser.details.juniors;
                    self.juniorId = self.getJuniorIdByName();
                    EventBus.$emit("user-load-dashboard-card", self.juniorId);
                    self.$console();
                    self.$console("Loaded juniors:");
                    self.$console({ juniors: self.juniors });
                    self.$console();
                    self.$console("Loaded data for junior - " + self.juniors[0].id + " - " + self.juniors[0].fullName);

                }
                else {
                    window.history.back();
                }
                self.isProcessing = false;
            }
        },
    },
    mounted() {
        var self = this;
        EventBus.$off("user-load-junior-one-day-membership-menu");
        EventBus.$on("user-load-junior-one-day-membership-menu", () => { self.getData(); });
        var currentJun = store.getters.getCurrentJunior;
        if (currentJun) {
            self.juniorName = currentJun;
        }
        self.getJuniors();
    }
}



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/junior/junior-one-day-membership-menu/junior-one-day-membership-menu.js